/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EvidenceErrors
 */
export interface EvidenceErrors {
    /**
     * 
     * @type {string}
     * @memberof EvidenceErrors
     */
    'detectedDpi'?: EvidenceErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceErrors
     */
    'calculatedDpi'?: EvidenceErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceErrors
     */
    'colorGradation'?: EvidenceErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceErrors
     */
    'heightMillis'?: EvidenceErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceErrors
     */
    'widthMillis'?: EvidenceErrorsWidthMillisEnum;
}

export const EvidenceErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceErrorsDetectedDpiEnum = typeof EvidenceErrorsDetectedDpiEnum[keyof typeof EvidenceErrorsDetectedDpiEnum];
export const EvidenceErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceErrorsCalculatedDpiEnum = typeof EvidenceErrorsCalculatedDpiEnum[keyof typeof EvidenceErrorsCalculatedDpiEnum];
export const EvidenceErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceErrorsColorGradationEnum = typeof EvidenceErrorsColorGradationEnum[keyof typeof EvidenceErrorsColorGradationEnum];
export const EvidenceErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceErrorsHeightMillisEnum = typeof EvidenceErrorsHeightMillisEnum[keyof typeof EvidenceErrorsHeightMillisEnum];
export const EvidenceErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceErrorsWidthMillisEnum = typeof EvidenceErrorsWidthMillisEnum[keyof typeof EvidenceErrorsWidthMillisEnum];


